import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AcuerdosHistoricosService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  getAcuerdosHistoricos(filter:any){
    return this.http.get(`${this.baserApiUrl}acuerdos-historicos?${filter}`,)
  }

}
